export default __webpack_public_path__ + "static/media/logo-mexico.28d136c1.png";